import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';

const AdminCookies = () => {
  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', key_name: '', purpose: '', provider: '', expiry: '', category: 'necessary', is_active: true });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [policy, setPolicy] = useState('');
  const [policySaving, setPolicySaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiBase}/backend/api.php?action=getCookies`);
      const data = await res.json();
      setItems(Array.isArray(data) ? data : []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${apiBase}/backend/api.php?action=getCookiePolicy`);
        const data = await res.json();
        setPolicy(data?.content || '');
      } catch (e) {}
    })();
  }, []);

  const startEdit = (item=null) => {
    setEditing(item?.id || null);
    setForm({
      name: item?.name || '',
      key_name: item?.key_name || '',
      purpose: item?.purpose || '',
      provider: item?.provider || (typeof window !== 'undefined' ? window.location.hostname : ''),
      expiry: item?.expiry || '',
      category: item?.category || 'necessary',
      is_active: (item?.is_active ?? 1) ? true : false,
    });
  };

  const save = async () => {
    setSaving(true);
    try {
      const body = { id: editing, ...form };
      await fetch(`${apiBase}/backend/api.php?action=upsertCookie`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      setMsg('Kaydedildi'); setTimeout(()=>setMsg(''), 2000);
      setEditing(null); setForm({ name: '', key_name: '', purpose: '', provider: '', expiry: '', category: 'necessary', is_active: true });
      await load();
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!confirm('Silinsin mi?')) return;
    await fetch(`${apiBase}/backend/api.php?action=deleteCookie&id=${encodeURIComponent(id)}`);
    await load();
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">Cookie Yönetimi</h1>
        <Button onClick={()=>startEdit(null)}>Yeni Cookie</Button>
      </div>
      {msg && <div className="mb-3 p-2 bg-green-50 border border-green-200 text-green-700 text-sm rounded">{msg}</div>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2 border rounded-lg p-4 bg-white">
          {loading ? 'Yükleniyor...' : (
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-600">
                  <th className="py-2">Ad</th>
                  <th>Key</th>
                  <th>Sağlayıcı</th>
                  <th>Kategori</th>
                  <th>Durum</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map(it => (
                  <tr key={it.id} className="border-t">
                    <td className="py-2">{it.name}</td>
                    <td>{it.key_name}</td>
                    <td>{it.provider}</td>
                    <td>{it.category}</td>
                    <td>{(it.is_active? 'Aktif':'Pasif')}</td>
                    <td className="text-right space-x-2">
                      <Button variant="outline" onClick={()=>startEdit(it)}>Düzenle</Button>
                      <Button variant="destructive" onClick={()=>remove(it.id)}>Sil</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="border rounded-lg p-4 bg-white">
          <h2 className="text-sm font-medium text-gray-700 mb-3">{editing? 'Cookie Düzenle':'Yeni Cookie'}</h2>
          <div className="space-y-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">Ad</label>
              <Input value={form.name} onChange={e=>{
                const v = e.target.value;
                setForm(f=>{
                  const next = { ...f, name: v };
                  // Otomatik key_name doldur (ilk kez veya boşsa)
                  if (!f.key_name || f.key_name.trim()==='') {
                    next.key_name = v
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g,'_')
                      .replace(/^_+|_+$/g,'');
                  }
                  // Sağlayıcı auto (hostname)
                  if (!f.provider || f.provider.trim()==='') {
                    next.provider = (typeof window !== 'undefined' ? window.location.hostname : '');
                  }
                  return next;
                });
              }} />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Key</label>
              <Input value={form.key_name} onChange={e=>setForm(f=>({...f,key_name:e.target.value}))} placeholder="otomatik doldurulur" />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Sağlayıcı</label>
              <Input value={form.provider} onChange={e=>setForm(f=>({...f,provider:e.target.value}))} placeholder="ör: website-al.com" />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Süre</label>
              <select className="w-full border rounded h-9 px-2" value={form.expiry} onChange={e=>setForm(f=>({...f,expiry:e.target.value}))}>
                <option value="">Seçiniz</option>
                <option value="session">Oturum (Session)</option>
                <option value="1 gün">1 gün</option>
                <option value="3 gün">3 gün</option>
                <option value="7 gün">7 gün</option>
                <option value="14 gün">14 gün</option>
                <option value="1 ay">1 ay</option>
                <option value="3 ay">3 ay</option>
                <option value="6 ay">6 ay</option>
                <option value="1 yıl">1 yıl</option>
                <option value="2 yıl">2 yıl</option>
                <option value="sınırsız">Sınırsız</option>
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Kategori</label>
              <select className="w-full border rounded h-9 px-2" value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>
                <option value="necessary">Gerekli</option>
                <option value="analytics">Analitik</option>
                <option value="marketing">Pazarlama</option>
                <option value="preferences">Tercihler</option>
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Metin (Amaç)</label>
              <Textarea value={form.purpose} onChange={e=>setForm(f=>({...f,purpose:e.target.value}))} placeholder="Cookie metni / amacı" />
            </div>
            <div className="flex items-center gap-2">
              <input id="is_active" type="checkbox" checked={form.is_active} onChange={e=>setForm(f=>({...f,is_active:e.target.checked}))} />
              <label htmlFor="is_active" className="text-sm">Aktif</label>
            </div>
            <div className="flex gap-2">
              <Button onClick={save} disabled={saving}>{saving? 'Kaydediliyor...':'Kaydet'}</Button>
              <Button variant="outline" onClick={()=>{setEditing(null); setForm({ name:'', key_name:'', purpose:'', provider:'', expiry:'', category:'necessary', is_active:true });}}>Temizle</Button>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 border rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between">
          <h2 className="text-sm font-medium text-gray-700">Çerez Politikası İçeriği</h2>
          <div className="flex items-center gap-2">
            <a className="text-sm text-purple-700 hover:underline" href="/cerez-politikasi" target="_blank" rel="noreferrer">Önizle</a>
            <Button onClick={async()=>{
              setPolicySaving(true);
              try {
                await fetch(`${apiBase}/backend/api.php?action=upsertCookiePolicy`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ content: policy }) });
                setMsg('Politika kaydedildi'); setTimeout(()=>setMsg(''),2000);
              } finally { setPolicySaving(false); }
            }} disabled={policySaving}>{policySaving?'Kaydediliyor...':'Kaydet'}</Button>
          </div>
        </div>
        <div className="mt-3">
          <Textarea value={policy} onChange={e=>setPolicy(e.target.value)} className="min-h-[220px]" placeholder="HTML içerik desteklenir" />
        </div>
      </div>
    </div>
  );
};

export default AdminCookies;


